import { render, staticRenderFns } from "./dutyInfo.vue?vue&type=template&id=277c2752&scoped=true&"
import script from "./dutyInfo.vue?vue&type=script&lang=js&"
export * from "./dutyInfo.vue?vue&type=script&lang=js&"
import style0 from "./dutyInfo.vue?vue&type=style&index=0&id=277c2752&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "277c2752",
  null
  
)

component.options.__file = "dutyInfo.vue"
export default component.exports